import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Table, Button } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import renderRadioButtonField from '../../../../../shared/components/form/RadioButton';

const renderField = ({
    input, placeholder, type, meta: { touched, error },
}) => (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
        <input {...input} placeholder={placeholder} type={type} />
        {touched && error && <span className="form__form-group-error">{error}</span>}
    </div>
);

renderField.propTypes = {
    input: PropTypes.shape().isRequired,
    placeholder: PropTypes.string,
    type: PropTypes.string,
    meta: PropTypes.shape({
        touched: PropTypes.bool,
        error: PropTypes.string,
    }),
};

renderField.defaultProps = {
    placeholder: '',
    meta: null,
    type: 'text',
};


class CriterialExclutionAndInclution extends Component {
    constructor(props) {
        super(props);
        this.state = {
            idPatientStudio: null
        }
    }

    componentDidMount = () => {
        this.getIDPatientClinicalStudio();
    }

    getIDPatientClinicalStudio = async () => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + `estudio-clinico-pacientes/consultar?id_historia=${this.props.id_historia}&id_estudio=${this.props.id_estudio}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();   
            }
            else
            {
                throw new Error("Ha ocurrido un error consultando el Estudiio Clinico");
            }
        }).then((data) => {
            if(data.paciente != null)
            {
                this.setState({
                    idPatientStudio: data.paciente.id_estudio_paciente
                }, () => {
                    this.props.handlerCriterialExclusionAndInclusion("Sí", "ENROLAMIENTO", null)
                });
            }
            console.log("dataClinicalEstudioPaciente",data);
        }).catch(error => {
            console.log(error);
        })
    }

    render() {

        return (
            <Col>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>

                    <h5 className="bold-text">Criterios de Inclusión</h5>

                    {this.props.criterialExcIncData.inclusion.length === 0 ? <h5> No se han agregado los criterios de Inclusión en este Estudio </h5> :
                        <Table bordered style={{ width: '60%', marginTop: 20 }}>
                            <thead>
                                <tr>
                                    <td>Item </td>
                                    <td >Criterio </td>
                                    <td >Confirmación </td>
                                </tr>
                            </thead>
                            <tbody>
                                {this.props.criterialExcIncData.inclusion.map((data, index) => {
                                    return <tr key={index}>
                                        <td>{data.orden}</td>
                                        <td style={{ width: '70%' }}>{data.descripcion}</td>
                                        <td><Field
                                            name={`confirm-inclusion-${index}`}
                                            component={renderRadioButtonField}
                                            label="Sí"
                                            radioValue={"Sí"}
                                            defaultChecked={
                                                this.props.criterialExcIncData.inclusion[index] != undefined && this.props.criterialExcIncData.inclusion[index] != null ?
                                                    this.props.criterialExcIncData.inclusion[index].confirmacion == true ? true : false : false
                                            }
                                            onChange={(e) => {
                                                this.props.handlerCriterialExclusionAndInclusion(e, "INCLUSION", index);
                                            }}
                                        />
                                            <Field
                                                name={`confirm-inclusion-${index}`}
                                                component={renderRadioButtonField}
                                                label="No"
                                                radioValue={"No"}
                                                defaultChecked={
                                                    this.props.criterialExcIncData.inclusion[index] != undefined && this.props.criterialExcIncData.inclusion[index] != null ?
                                                        this.props.criterialExcIncData.inclusion[index].confirmacion == false ? true : false : false
                                                }
                                                onChange={(e) => {
                                                    this.props.handlerCriterialExclusionAndInclusion(e, "INCLUSION", index);
                                                }}
                                            /></td>
                                    </tr>
                                })
                                }
                            </tbody>
                        </Table>
                    }

                    <h5 className="bold-text">Criterios de Exclusión</h5>

                    {this.props.criterialExcIncData.exclusion.length === 0 ? <h5> No se han agregado los criterios de Exclusión en este Estudio </h5> :
                        <Table bordered style={{ width: '60%', marginTop: 20 }}>
                            <thead>
                                <tr>
                                    <td>Item </td>
                                    <td >Criterio </td>
                                    <td >Confirmación </td>
                                </tr>
                            </thead>
                            <tbody>
                                {this.props.criterialExcIncData.exclusion.map((data, index) => {
                                    return <tr key={index}>
                                        <td>{data.orden}</td>
                                        <td style={{ width: '70%' }}>{data.descripcion}</td>
                                        <td><Field
                                            name={`confirm-exclusion-${index}`}
                                            component={renderRadioButtonField}
                                            label="Sí"
                                            radioValue={"Sí"}
                                            defaultChecked={
                                                this.props.criterialExcIncData.exclusion[index] != undefined && this.props.criterialExcIncData.exclusion[index] != null ?
                                                    this.props.criterialExcIncData.exclusion[index].confirmacion == false ? true : false : false
                                            }
                                            onChange={(e) => {
                                                this.props.handlerCriterialExclusionAndInclusion(e, "EXCLUSION", index);
                                            }}
                                        />
                                            <Field
                                                name={`confirm-exclusion-${index}`}
                                                component={renderRadioButtonField}
                                                label="No"
                                                radioValue={"No"}
                                                defaultChecked={
                                                    this.props.criterialExcIncData.exclusion[index] != undefined && this.props.criterialExcIncData.exclusion[index] != null ?
                                                        this.props.criterialExcIncData.exclusion[index].confirmacion == false ? true : false : false
                                                }
                                                onChange={(e) => {
                                                    this.props.handlerCriterialExclusionAndInclusion(e, "EXCLUSION", index);
                                                }}
                                            /></td>
                                    </tr>
                                })
                                }
                            </tbody>
                        </Table>
                    }

                    <div style={{ display: 'flex', marginTop: 50, }}>

                        <div style={{ marginRight: 20, width: '90%' }} >
                            <span className="form__form-group-label" > {this.props.textPatientStudioContain} </span>
                        </div>
                        <div className="form__form-group-field"  >

                            <Field
                                name="enroled"
                                component={renderRadioButtonField}
                                label="Sí"
                                defaultChecked={this.props.criterialExcIncData.enrolado == 'Sí' ? true : false}
                                radioValue={"Sí"}
                                onChange={(e) => {
                                    this.props.handlerCriterialExclusionAndInclusion(e, "ENROLAMIENTO", null);
                                }}
                            />
                            <Field
                                name="enroled"
                                component={renderRadioButtonField}
                                label="No"
                                radioValue={"No"}
                                defaultChecked={this.props.criterialExcIncData.enrolado == 'No' ? true : false}
                                onChange={(e) => {
                                    this.props.handlerCriterialExclusionAndInclusion(e, "ENROLAMIENTO", null);
                                }}
                            />

                            {this.props.criterialExcIncData.enrolado === "Sí" && this.state.idPatientStudio != null ?
                                <div className="form__form-group-field" >
                                    <span className="form__form-group-label" style={{ marginRight: 20 }}> Id Paciente</span>
                                    <input
                                        disabled={true}
                                        name="product-text"
                                        component={renderField}
                                        type="text"
                                        style={{ width: '30%', }}
                                        value={this.state.idPatientStudio}
                                    />
                                </div>
                            : null}
                        </div>
                    </div>
                </div>
            </Col>
        );
    }
}

export default reduxForm({
    form: `criteria-form`, // a unique identifier for this form
})(withTranslation('common')(CriterialExclutionAndInclution));